export const esCompaniaElectric = (compania) =>
  String(compania || '').trim().toUpperCase() === 'ELECTRIC'

const RENOMBRES_FILAS = {
  'Inventario Inicial SITIO Tecnosuper + Auteco':
    'Inventario Inicial en sitio Tecnosuper + Auteco',
  'Inventario tecnosuper': 'Inventario Inicial en sitio Tecnosuper',
  'Sell In Tecno Super': 'Sell In Tecnosuper',
  'Sell Out Tecno Super': 'Sell Out Tecnosuper',
  'Facturación Tecno & Auteco': 'Facturación Tecnosuper + Auteco',
  'Inventario Final SITIO Teórico Total': 'Inventario final Tecnosuper + Auteco',
}

export const normalizarNombreFila = (fila) => RENOMBRES_FILAS[fila] || fila

export const FILAS_ELECTRIC = [
  {
    label: 'Inventario Inicial en sitio Tecnosuper + Auteco',
    field: 'inventario_inicial_sitio',
  },
  {
    label: 'Inventario Inicial en sitio Tecnosuper',
    field: 'inventario_inicial_tecnosuper',
  },
  {
    label: 'Facturación Tecnosuper + Auteco',
    field: 'facturacion_tecno_auteco',
  },
  {
    label: 'Inventario final Tecnosuper + Auteco',
    field: 'inventario_final_sitio',
  },
  {
    label: 'Inventario final Tecnosuper',
    field: 'inventario_final_tecnosuper',
  },
]

const FILAS_OCULTAS_POR_DEFECTO = [
  'Rolling',
  'Inventario final UN (PV) teórico',
  'Licitacion',
]

export const getTodasLasFilasPlanificacion = () => {
  const electricLabels = FILAS_ELECTRIC.map((fila) => fila.label)

  return [
    electricLabels[0],
    'Inventario Inicial en sitio',
    electricLabels[1],
    'Pedido a proveedor',
    'Llegadas (Und)',
    'Llegadas (Cont)',
    'Sell In -- Plan Ventas',
    'Sell In Tecnosuper',
    'Sell In Sin Tecno Super',
    'Licitacion',
    'Sell Out Tecnosuper',
    'Sell Out',
    electricLabels[2],
    'Rolling',
    electricLabels[3],
    'Inventario final UN (PV) teórico',
    'Inventario final UN (PV) real',
    electricLabels[4],
    'Días Inventario objetivo final (PV)',
    'Comentarios',
  ]
}

export const getFilasVisiblesPorDefecto = (compania) => {
  const ocultasPorDefecto = [...FILAS_OCULTAS_POR_DEFECTO]
  if (!esCompaniaElectric(compania)) {
    FILAS_ELECTRIC.forEach((fila) => ocultasPorDefecto.push(fila.label))
  }
  return getTodasLasFilasPlanificacion().filter(
    (fila) => !ocultasPorDefecto.includes(fila),
  )
}

export const getTiposDatosPlanificacion = () =>
  getTodasLasFilasPlanificacion().filter((fila) => fila !== 'Comentarios')

export const getCampoBasePorTipoDato = () => {
  const map = {
    'Inventario Inicial en sitio': 'inventario_inicial',
    'Pedido a proveedor': 'pedidos_a_proveedor',
    'Llegadas (Und)': 'llegadas_unidades_totales',
    'Llegadas (Cont)': 'llegadas_contenedor_totales',
    'Sell In -- Plan Ventas': 'sell_in',
    'Sell In Tecnosuper': 'sell_in_tecnosuper',
    'Sell In Sin Tecno Super': 'sell_in',
    Licitacion: 'licitacion',
    'Sell Out Tecnosuper': 'sell_out_tecnosuper',
    'Sell Out': 'sell_out',
    Rolling: 'rolling',
    'Inventario final UN (PV) teórico': 'inventario_final_un_pv_teorico',
    'Inventario final UN (PV) real': 'inventario_final_un_pv_real',
    'Días Inventario objetivo final (PV)': 'inventario_final_dias_pv',
  }

  FILAS_ELECTRIC.forEach(({ label, field }) => {
    map[label] = field
  })

  return map
}

export const getValorCeldaPlanificacion = (tipo, datosDelPeriodo) => {
  if (!datosDelPeriodo) return '0'

  switch (tipo) {
    case 'Inventario Inicial en sitio':
      return parseInt(datosDelPeriodo.inventario_inicial, 10) || '0'
    case 'Pedido a proveedor':
      return parseInt(datosDelPeriodo.pedidos_a_proveedor, 10) || '0'
    case 'Llegadas (Und)':
      return parseInt(datosDelPeriodo.llegadas_unidades_totales, 10) || '0'
    case 'Llegadas (Cont)':
      return parseInt(datosDelPeriodo.llegadas_contenedor_totales, 10) || '0'
    case 'Sell In -- Plan Ventas':
      return parseInt(datosDelPeriodo.sell_in, 10) || '0'
    case 'Sell In Tecnosuper':
      return (
        parseInt(datosDelPeriodo.sell_in_tecnosuper, 10) ||
        parseFloat(datosDelPeriodo.sell_in_tecnosuper) ||
        '0'
      )
    case 'Sell In Sin Tecno Super': {
      const sellInPlanVentas = parseFloat(datosDelPeriodo.sell_in) || 0
      const sellInTecnoSuper = parseFloat(datosDelPeriodo.sell_in_tecnosuper) || 0
      return sellInPlanVentas - sellInTecnoSuper
    }
    case 'Licitacion':
      return datosDelPeriodo.licitacion !== undefined
        ? parseInt(datosDelPeriodo.licitacion, 10) || '0'
        : '0'
    case 'Sell Out Tecnosuper':
      return (
        parseInt(datosDelPeriodo.sell_out_tecnosuper, 10) ||
        parseFloat(datosDelPeriodo.sell_out_tecnosuper) ||
        '0'
      )
    case 'Sell Out':
      return parseInt(datosDelPeriodo.sell_out, 10) || '0'
    case 'Rolling':
      return parseInt(datosDelPeriodo.rolling, 10) || '0'
    case 'Inventario final UN (PV) teórico':
      return datosDelPeriodo.inventario_final_un_pv_teorico || '0'
    case 'Inventario final UN (PV) real':
      return parseInt(datosDelPeriodo.inventario_final_un_pv_real, 10) || '0'
    case 'Días Inventario objetivo final (PV)':
      return datosDelPeriodo.inventario_final_dias_pv !== undefined &&
        datosDelPeriodo.inventario_final_dias_pv
        ? parseInt(datosDelPeriodo.inventario_final_dias_pv, 10)
        : '0'
    default: {
      const electricField = FILAS_ELECTRIC.find((fila) => fila.label === tipo)?.field
      if (!electricField) return '0'
      const valor = datosDelPeriodo[electricField]
      if (valor === undefined || valor === null || valor === '') return '0'
      const parsed = parseInt(valor, 10)
      return Number.isNaN(parsed) ? valor : parsed
    }
  }
}
